/* eslint-disable no-restricted-imports */
import type { IconBlobProps } from '@glovo/uds-react'
import { IconBlobType } from '@glovo/uds-react'

export interface IconBlobExtendedProps extends Omit<IconBlobProps, 'type'> {
  type: IconBlobTypeExtendedType
}

export enum IconBlobTypeExtended {
  neutral = IconBlobType.neutral,
  promotion = IconBlobType.promotion,
  positive = IconBlobType.positive,
  critical = IconBlobType.critical,
  marketing = IconBlobType.marketing,
  loyalty = 'loyalty',
}

export type IconBlobTypeExtendedType = `${IconBlobTypeExtended}`
